export default __webpack_public_path__ + "static/char-21-anr-641a057726bbe6e6808ee723b434e937.gif";